// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component } from '@angular/core';

//Components
//import { GridLayoutComponent } from './gridLayout';
//import { FormLayoutComponent } from './formLayout';

//Services

//Token
import { authToken } from '../../shared/authToken';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PracticesComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
  template : '<router-outlet></router-outlet>',
  styles : [''],
  providers : []
})
export class PracticesComponent implements OnInit{


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){
    //    //this.constructor.mapParams( this, arguments );
    //};

    //==================================
    // ngOnInit
    //==================================
    //ngOnInit(){
    //};
  
}

